// ProtectedRoute.js
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "./layout/SideBar";
import { jwtDecode } from "jwt-decode";
import { handleUser, logout } from "./features/auth/authSlice";
import { useEffect } from "react";
import axiosInstance from "./instance";
import { getOrgNotifications } from "./features/fetch/fetchSlice";

export const ProtectedRoute = ({ role }) => {
  const { isActive } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  axiosInstance.defaults.headers.common = { Authorization: `Bearer ${token}` };

  async function handleDecodeToken() {
    try {
      let tokenObj = jwtDecode(token);
      await dispatch(handleUser(tokenObj));
    } catch {
      await dispatch(handleUser({}));
    }
  }

  async function handleInit() {
    if (token) await handleDecodeToken();
  }

  async function handleLogout() {
    await dispatch(logout());
    await localStorage.clear();
    await navigate("/#/login");
  }

  async function getOrgNotificationsData() {
    await dispatch(
      getOrgNotifications({
        url: "api/v1/notification/getOrgNotifications",
        notStatus: "UNREAD",
      })
    );
  }

  useEffect(() => {
    if (!token) {
      handleLogout();
    } else {
      handleInit();
      getOrgNotificationsData();
    }
  }, [token, pathname]);

  if (!isActive && !token) {
    return <Navigate to="/#/login" replace />;
  }

  return (
    <div className="flex items-start justify-start w-full h-[92vh]">
      <SideBar />
      <Outlet />
    </div>
  );
};
